import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import {
	getReservation,
	getReservationById,
	getReservationTime,
	setReservationFormData,
	initReservationFormData,
	getReservationDate,
} from 'actions/reservation';
import { closeAlert } from 'actions/alert';

import AllCountries from 'util/country';
import { serverMapEmpty } from 'util/helper';

import CancelRoute from './Cancel';
import EditRoute from './Edit';

export default store => ({
	path: 'reservation',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'Reservation',
				),
			store,
			'RESERVATION',
		),
		onEnter: withAsyncEnterLoader(
			async (_, __, updateRatio) => {
				// 	updateRatio(0.3);

				await store.dispatch(getReservation());
				updateRatio(0.8);
			},
			store,
			'ENTER_RESERVATION',
		),
	},
	childRoutes: [
		{
			path: ':id',
			indexRoute: {
				component: null,
				onEnter: ({ params: { lang } }, replace) => replace(`/${lang}/user/reservation`),
			},
			onEnter: withAsyncEnterLoader(
				async ({ params: { id }, location: { pathname } }, __, updateRatio) => {
					store.dispatch(closeAlert('reserve'));
					await store.dispatch(getReservationById(id));

					if (pathname.includes('edit')) {
						const { reservation: { reservations: { data } } } = store.getState();

						store.dispatch(initReservationFormData());

						updateRatio(0.6);

						await Promise.all([
							store.dispatch(getReservationTime(data[id].work_date, data[id].room_id, 'MORNING')),
							store.dispatch(getReservationTime(data[id].work_date, data[id].room_id, 'AFTERNOON')),
							store.dispatch(
								setReservationFormData(
									{
										value: serverMapEmpty(data[id].user.phone),
										country: AllCountries.getCountryByCode(data[id].user.phone_country),
									},
									{ value: serverMapEmpty(data[id].user.hangout) },
								),
							),
							store.dispatch(getReservationDate(data[id].work_date, data[id].room_id)),
						]);
					}
					updateRatio(0.8);
				},
				store,
				'ENTER_RESERVATION_BY_ID',
			),
			childRoutes: [CancelRoute(store), EditRoute(store)],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/User/ReservationRecord/index.js